import { mdiDiamondStone } from "@mdi/js";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { PREMIUM_PATH } from "../../../extensions/nexus_integration/constants";
import { isPremium as isPremiumSelector, shouldShowPremiumAd, } from "../../../extensions/nexus_integration/selectors";
import { Button } from "../../../ui/components/button/Button";
import { Typography } from "../../../ui/components/typography/Typography";
import opn from "../../../util/opn";
import { Campaign, Content, nexusModsURL, Section } from "../../../util/util";
export const PremiumIndicator = () => {
    const { t } = useTranslation();
    const showAd = useSelector(shouldShowPremiumAd);
    const premium = useSelector(isPremiumSelector);
    const handleGoPremium = useCallback(() => {
        opn(nexusModsURL(PREMIUM_PATH, {
            section: Section.Users,
            campaign: Campaign.BuyPremium,
            content: Content.HeaderAd,
        })).catch(() => undefined);
    }, []);
    if (premium) {
        return (React.createElement(Typography, { appearance: "moderate", typographyType: "title-sm" }, t("Premium")));
    }
    if (showAd) {
        return (React.createElement(Button, { buttonType: "premium", leftIconPath: mdiDiamondStone, size: "sm", onClick: handleGoPremium }, t("Go premium")));
    }
    return null;
};
